export enum ConsumerViewTabEnum {
  Integrations = 'integrations',
  Logs = 'logs',
  Api = 'api',
  Settings = 'settings',
}
